import { StorageKeys } from '@procom-labs/common'

import { IAuthCredential } from '../models'

export const atsCredStorage = {
  get: (): IAuthCredential | null => {
    const rawValue = localStorage.getItem(StorageKeys.Credentials)
    if (!rawValue) return null

    return JSON.parse(rawValue) as IAuthCredential
  },
  set: (v: IAuthCredential) => {
    window.localStorage.setItem(StorageKeys.Credentials, JSON.stringify(v))
  },
  clear: () => {
    window.localStorage.removeItem(StorageKeys.Credentials)
  },
}
